var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{class:_vm.ClassObject,attrs:{"title":_vm.taskTitle}},[_vm._v(_vm._s(_vm.taskTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }